export default __webpack_public_path__ + "static/media/sn-help-machine-it.5d805480.jpg";